const api = {
  xhrFunc: null,
  syncXhrFunc: (internalApi: any) => {
    api.xhrFunc = internalApi;
    return api;
  },

  call: async <T = any>(_url: string, _method: string, _data: any, _config?: any): Promise<{ data: T }> => {
    if (!api.xhrFunc) {
      throw new Error('apiService: Attempted to call API before synchronization. Ensure ProjectSocAutomationProvider is mounted.');
    }

    const fn: any = api.xhrFunc;
    const params: { [key: string]: any } = {
      options: { method: _method, ..._config },
      muteErrors: true,
      isWebserver: false,
      resolveNullResponse: _method === 'DELETE',
    };
    if (_data != null) {
      params.body = _data;
    }
    const p = fn(`socautomation/${_url}`, params);

    const respFunc = function f(value) {
      return { data: value };
    };
    return p.then(respFunc);
  },

  get: async <T = any>(_url: string, _config?: any): Promise<{ data: T }> => api.call(_url, 'GET', null, _config),

  post: async <T = any>(_url: string, _data?: any, _config?: any): Promise<{ data: T }> => api.call(_url, 'POST', _data, _config),

  patch: async <T = any>(_url: string, _data?: any, _config?: any): Promise<{ data: T }> => api.call(_url, 'PATCH', _data, _config),

  delete: async <T = any>(_url: string, _data?: any, _config?: any): Promise<{ data: T }> => api.call(_url, 'DELETE', _data?.data, _config),
};

export default api;
